module.exports = "<div class=\"static-row row {{remove ? 'action-deleting' : ''}}\">\n  <div class=\"col-xs-7\">\n    <span>{{hostname|e}}</span>\n  </div>\n  <div class=\"col-xs-5 column\">\n    <span>{{ip|e}}</span>\n  </div>\n</div>\n";
